<!-- Icon -->
<!--
    One element per variant with a STATIC `icon`, rather than one element with a bound path.
    `IconShapesDirective.ngOnChanges` reacts to `variant` only — a changed `icon` is never applied
    after the first render, so a banner that goes from "working" to "done" would keep the old glyph.
    Separate elements let Angular destroy and rebuild, which re-runs the directive with the right one.

    The variant names are the ICON stylesheet's classes, not palette tokens: the directive adds the
    value as a CSS class and the glyph gets its colour from that class. A name with no rule renders an
    invisible icon and an empty gap — which is exactly what `gray600`/`green800` did here.
-->
<span
    *ngIf="variant === 'warning'"
    hamIconShapes
    class="icon"
    icon="assets/hamIcons/exclamation-outline.svg"
    [variant]="'orange800'"
    [size]="'regular'"
></span>
<span
    *ngIf="variant === 'progress'"
    hamIconShapes
    class="icon icon--spinning"
    icon="assets/hamIcons/rotate-outline.svg"
    [variant]="'green'"
    [size]="'regular'"
></span>
<span
    *ngIf="variant === 'success'"
    hamIconShapes
    class="icon"
    icon="assets/hamIcons/check-circle-outline.svg"
    [variant]="'dark-green'"
    [size]="'regular'"
></span>
<!-- Text -->
<div class="banner-content">
    <span *ngIf="messageLocalizationKey" class="banner-text">{{ messageLocalizationKey | i18next }}</span>
    <span *ngIf="!messageLocalizationKey && message" class="banner-text"
        >{{ displayMessage }}
        <a *ngIf="hasLink" [href]="linkUrl" target="_blank" rel="noopener noreferrer" class="announcement-link">
            {{ linkUrl }}
        </a></span
    >
    <!-- Link inline after message -->
</div>

<!-- ← Spacer takes all the remaining space → -->
<div class="flex-spacer"></div>

<!-- Dismiss button (X) -->
<ham-button *ngIf="dismissible" variant="glass" [size]="'xs'" icon="assets/hamIcons/x.svg" (buttonClick)="onDismiss()">
</ham-button>

<!-- Action button -->
<ham-button
    *ngIf="hasButton"
    variant="glass" outline="true" size="xs"
    [disabled]="disabled"
    [hamDisabledTooltip]="disabledTooltip"
    (buttonClick)="onConfirm()"
    >{{ buttonLocalizationKey | i18next 
}}</ham-button>

